import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonButton } from '@ionic/angular/standalone';

/**
 * "Couldn't load the …" card with Try again — what a page shows instead of
 * an empty list or a spinner when its data didn't come back, so an outage
 * never reads as "there's nothing here".
 */
@Component({
  selector: 'admin-load-failed',
  standalone: true,
  imports: [IonButton],
  template: `
    <div class="load-failed" role="alert">
      <span class="material-symbols-outlined" aria-hidden="true">cloud_off</span>
      <div class="load-failed__text">
        <strong>Couldn't load the {{ what }}.</strong>
        <p>{{ detail || "The server didn't answer. Try again in a moment." }}</p>
      </div>
      <ion-button fill="outline" size="small" (click)="retry.emit()">Try again</ion-button>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .load-failed {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 14px;
        text-align: start;
      }
      .material-symbols-outlined {
        color: var(--cnt-danger);
        font-size: 28px;
      }
      .load-failed__text {
        flex: 1 1 240px;
      }
      p {
        margin: 2px 0 0;
        color: var(--cnt-muted);
        font-size: 0.875rem;
      }
    `,
  ],
})
export class AdminLoadFailedComponent {
  /** What didn't load, as it reads after "the": "listings", "user", "report". */
  @Input({ required: true }) what = '';
  /** Replaces the default "The server didn't answer…" line. */
  @Input() detail = '';
  @Output() readonly retry = new EventEmitter<void>();
}
